import type { IDecimalValueAndUnit } from '@/interfaces'
import Base from './Base'
import type { IConfig } from '@/interfaces/IConfig'
import { CostUnitLabelType } from '@/enum'

class Config extends Base implements IConfig {
  defPrice: IDecimalValueAndUnit
  fuelPrice: IDecimalValueAndUnit

  constructor(data?: any) {
    super(data)
    this.defPrice = data?.defPrice ?? { value: null, unit: CostUnitLabelType.GBP }
    this.fuelPrice = data?.fuelPrice ?? { value: null, unit: CostUnitLabelType.GBP }
  }
}

export default Config
